import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import Cookies from 'universal-cookie';
import { getFavoritesData } from '../../../helpers/favorites';

const useGetFavorites = () => {
  const { locale } = useRouter();

  const clientId = new Cookies().get('clientID', { doNotParse: true });

  const {
    data: favorites,
    isLoading,
    isError
  } = useQuery([], () => getFavoritesData(clientId, locale), {
    enabled: !!clientId,
    cacheTime: 3000
  });

  return {
    favorites: favorites ?? { compounds: [], properties: [] },
    isLoading,
    isError
  };
};
export default useGetFavorites;
